class LoopProductGallery extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.photos = [...this.querySelectorAll('[data-gallery-photo]')];
    this.index = Math.max(0, this.photos.findIndex(photo => photo.getAttribute('aria-pressed') === 'true'));
    this.main = this.querySelector('.lp-gallery-main');
    this.zoomLink = this.querySelector('.lp-gallery-zoom');
    this.dialog = this.querySelector('dialog');
    this.closest('.shopify-section, dialog')?.addEventListener('click', event => {
      if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
      const picker = event.target.closest('variant-picker');
      if (!picker) return;
      const input = event.target.matches('input[type="radio"]')
        ? event.target
        : event.target.closest('label')?.querySelector('input[type="radio"]');
      if (input?.checked && input.dataset.variantId === this.dataset.selectedVariantId) this.selectVariantMedia();
    }, { signal });
    this.addEventListener('click', event => {
      const thumb = event.target.closest('[data-gallery-photo]');
      const direction = event.target.closest('[data-gallery-direction]');
      if (thumb) this.select(this.photos.indexOf(thumb));
      if (direction) this.select(this.index + Number(direction.dataset.galleryDirection));
      if (event.target.closest('[data-gallery-close]')) this.dialog.close();
      if (event.target.closest('.lp-gallery-zoom')) {
        event.preventDefault();
        if (this.swiped) { this.swiped = false; return; }
        const enlarged = this.dialog.querySelector('img');
        enlarged.src = this.photos[this.index].dataset.src;
        enlarged.alt = this.main.alt;
        this.dialog.showModal();
      }
      if (event.target === this.dialog) this.dialog.close();
    }, { signal });
    this.addEventListener('keydown', event => {
      if (this.dialog.open || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      this.select(event.key === 'Home' ? 0 : event.key === 'End' ? this.photos.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1));
      if (event.target.closest('[data-gallery-photo]')) this.photos[this.index].focus({ preventScroll: true });
    }, { signal });
    this.zoomLink.addEventListener('pointerdown', event => {
      this.swiped = false;
      this.start = { x: event.clientX, y: event.clientY };
    }, { signal });
    this.zoomLink.addEventListener('pointerup', event => {
      if (!this.start) return;
      const dx = event.clientX - this.start.x;
      const dy = event.clientY - this.start.y;
      this.start = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        this.swiped = true;
        this.select(this.index + (dx < 0 ? 1 : -1));
      }
    }, { signal });
    this.zoomLink.addEventListener('pointercancel', () => { this.start = null; }, { signal });
    this.zoomLink.addEventListener('dragstart', event => event.preventDefault(), { signal });
  }

  disconnectedCallback() { this.controller?.abort(); }

  selectVariantMedia() {
    const mediaId = this.dataset.selectedMediaId;
    if (!mediaId) return;
    const index = this.photos.findIndex(photo => photo.dataset.mediaId === mediaId);
    if (index < 0) return;
    this.select(index);
    if (!matchMedia('(max-width: 749px)').matches) return;
    requestAnimationFrame(() => {
      if (!this.isConnected) return;
      const topBars = [...document.querySelectorAll('#header-component, .lp-world-nav')];
      const offset = Math.min(window.innerHeight / 3, Math.max(0, ...topBars.map(el => el.getBoundingClientRect().bottom))) + 12;
      const photo = this.main.getBoundingClientRect();
      const visible = Math.max(0, Math.min(photo.bottom, window.innerHeight) - Math.max(photo.top, offset));
      if (visible >= Math.min(photo.height, window.innerHeight - offset) * 0.6) return;
      window.scrollTo({top: Math.max(0, window.scrollY + photo.top - offset), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    });
  }

  select(index) {
    this.index = (index + this.photos.length) % this.photos.length;
    const selected = this.photos[this.index];
    this.main.srcset = selected.dataset.srcset;
    this.main.src = selected.dataset.src;
    this.main.alt = selected.dataset.alt;
    this.zoomLink.href = selected.dataset.src;
    this.querySelector('[data-gallery-note]').textContent = selected.dataset.note;
    this.querySelector('[data-gallery-count]').textContent = `${this.index + 1} / ${this.photos.length}`;
    this.photos.forEach(photo => photo.setAttribute('aria-pressed', String(photo === selected)));
    const strip = this.querySelector('.lp-gallery-thumbnails');
    const left = selected.offsetLeft - strip.offsetLeft;
    if (left < strip.scrollLeft || left + selected.offsetWidth > strip.scrollLeft + strip.clientWidth) {
      strip.scrollTo({ left: left - (strip.clientWidth - selected.offsetWidth) / 2, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
  }
}

if (!customElements.get('loop-product-gallery')) customElements.define('loop-product-gallery', LoopProductGallery);
